import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as _ from "lodash";

@Component({
  selector: "select-form-input",
  templateUrl: "select-form-input.html",
})
export class SelectFormInputComponent implements OnInit {
  @Input() set inputOptions(incomingOptions: object) {
    let initialLoad = !this.incomingOptions || this.incomingOptions.length == 0;
    this.incomingOptions = incomingOptions;
    if (
      this.inputForm &&
      initialLoad &&
      this.inputForm.controls["input"].dirty
    ) {
      initialLoad = false;
    }
    this.initializeOptions(!initialLoad);
  }

  @Input() set group(parentFormGroup: FormGroup) {
    this.parentFormGroup = parentFormGroup;
    this.watchForDisable();
  }

  @Input() controlName: string;
  @Input() labelText: string;
  @Input() includeOther: boolean = false;
  @Input() disabled: boolean = false;
  @Input() multipleOption: boolean = false;

  @Input() set data(incomingData: object) {
    this.existingData = incomingData;
    if (this.existingData) this.openedForEdit = true;
    //this.initializeOptions();
  }

  @Input() textMaxLength: number = 300;
  @Input() required: boolean = false;

  existingData: any;
  incomingOptions: any;
  parentFormGroup: FormGroup;
  openedForEdit: boolean = false;

  private inputForm: FormGroup;

  showOther: boolean = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.multipleOption
      ? this.initializeMultipleOption()
      : this.initializeOptions();
  }

  initializeOptions(newOptions: boolean = false): void {
    if (!this.labelText) {
      this.labelText = this.controlName;
    }
    let inputDefault = null,
      otherDefault = null;
    if (this.existingData) {
      let foundOption = this.incomingOptions.find((option) => {
        if (typeof option.value === "object") {
          let found = false;
          Object.keys(option.value).forEach((key) => {
            if (
              Object.keys(this.existingData).includes(key) &&
              this.existingData[key] === option.value[key]
            ) {
              found = true;
              this.existingData = option;
            }
          });
          return found;
        } else {
          return option.value == this.existingData;
        }
      });

      if (foundOption) {
        inputDefault = foundOption.value;
        this.showOther = false;
      } else {
        if (newOptions) {
          otherDefault = "";
          this.showOther = false;
          inputDefault = null;
        } else {
          otherDefault = this.existingData;
          this.showOther = true;
        }
      }
    } else {
      if (newOptions) {
        this.showOther = false;
      }
    }

    this.inputForm = this.formBuilder.group({
      input: [
        (otherDefault ? "other" : inputDefault) || "",
        this.required ? Validators.compose([Validators.required]) : null,
      ],
      other: [otherDefault || ""],
    });

    this.inputForm.valueChanges.subscribe((data) => {
      let val =
        this.multipleOption && this.controlName == "administeredBy"
          ? this.getMultipleValues(data)
          : data.input;
      if (data.input === "other" || _.includes(data.input, "other")) {
        val = this.multipleOption
          ? data.other
            ? this.getMultipleValues(data)
            : ""
          : data.other;
        this.showOther = true;
      } else {
        this.showOther = false;
      }
      this.parentFormGroup.controls[this.controlName].setValue(val);
    });

    //enforce character limit
    let otherInput = this.inputForm.controls["other"];
    otherInput.valueChanges.subscribe((data) => {
      if (data.length > this.textMaxLength) {
        otherInput.setValue(data.substring(0, this.textMaxLength));
      }
    });
  }

  setValue(data) {
    let foundOption = this.incomingOptions.find((option) => {
      if (typeof option.value === "object") {
        let found = false;
        Object.keys(option.value).forEach((key) => {
          if (data) {
            if (
              Object.keys(data).includes(key) &&
              data[key] === option.value[key]
            ) {
              found = true;
              data = option;
            }
          }
        });
        return found;
      } else {
        return option.value === data;
      }
    });

    if (foundOption) {
      this.inputForm.controls["input"].setValue(foundOption.value);
    } else {
      this.inputForm.controls["input"].setValue("other");
      this.inputForm.controls["other"].setValue(data);
    }
  }

  reset() {
    if (this.inputForm) {
      if (this.showOther) {
        this.inputForm.controls["other"].setValue("");
      }
      this.inputForm.controls["input"].setValue("");
      this.parentFormGroup.controls[this.controlName].setValue(null);
    }
  }

  watchForDisable() {
    this.parentFormGroup.valueChanges.subscribe((data) => {
      if (this.parentFormGroup.controls[this.controlName].disabled) {
        if (this.inputForm.controls["input"].enabled) {
          this.inputForm.controls["input"].disable();
          this.inputForm.controls["other"].disable();
          this.watchForValueSet();
        }
      } else {
        if (this.inputForm.controls["input"].disabled) {
          this.inputForm.controls["input"].enable();
          this.inputForm.controls["other"].enable();
        }
      }
    });
  }

  watchForValueSet() {
    this.parentFormGroup.controls[this.controlName].valueChanges.subscribe(
      (data) => {
        let currentInputVal = this.inputForm.controls["input"].value;
        let currentOtherVal = this.inputForm.controls["other"].value;
        if (
          (currentInputVal != data && currentInputVal != "other") ||
          (currentInputVal === "other" && currentOtherVal !== data)
        ) {
          if (data) {
            this.setValue(data);
          }
        }
      }
    );
  }
  // Multiple selection required Key value pair.
  getMultipleValues(data) {
    let incomingOpt = this.getMultipleKeys();
    if (!_.isEmpty(data.input)) {
      let multipleOpt = { data: {} };
      _.forEach(data.input, (o) => {
        if (o == "other") {
          multipleOpt["data"][o] = data.other;
        } else if (_.includes(incomingOpt, o)) {
          multipleOpt["data"][o] = o;
        }
      });
      return multipleOpt;
    }
    return "";
  }

  initializeMultipleOption() {
    let incomingOpt = [];
    if (!this.labelText) {
      this.labelText = this.controlName;
    }
    if (this.existingData) {
      let selectedOpt = [];
      if (this.controlName == "administeredBy") {
        incomingOpt = this.getMultipleKeys();
        if (_.has(this.existingData, "data")) {
          selectedOpt = Object.keys(this.existingData["data"]);
          if (_.includes(selectedOpt, "other")) {
            this.inputForm.controls["other"].setValue(
              this.existingData.data.other
            );
          }
        } else {
          selectedOpt = this.existingData
            .toString()
            .replace(/\s/g, "")
            .split(",");
          let diff = _.difference(selectedOpt, incomingOpt);
          if (!_.isEmpty(diff)) {
            selectedOpt.push("other");
            this.inputForm.controls["other"].setValue(diff[0]);
          }
        }
        this.inputForm.controls["input"].setValue(selectedOpt);
      } else if (_.isArray(this.existingData)) {
        selectedOpt = _.cloneDeep(this.existingData);
        this.inputForm.controls["input"].setValue(selectedOpt, {
          emitEvent: false,
        });
      }
    }
  }

  getMultipleKeys() {
    let incomingOpt = [];
    _.forEach(this.incomingOptions, (element) => {
      incomingOpt.push(element.display);
    });
    return incomingOpt;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/select-form-input/select-form-input.ts